import React, {Component} from 'react';

import {Field} from 'react-final-form';

export default creditor => (
  <table>
    <thead>
      <tr>
        <td colSpan="2"></td>
        <td className="total-claim">
          <label>
            <span className="label">Total claim</span>
          </label>
        </td>
        <td className="priority-amount">
          <label>
            <span className="label">Priority amount</span>
          </label>
        </td>
      </tr>
    </thead>
    <tbody>

    <tr>
      <td>
        <div className="form-item">
          <label>
            <span className="label">Priority creditor's name and mailing address </span>
          </label>
          <Field name={`${creditor}.creditor`} component="textarea"
                 rows="4" cols="35" placeholder="Creditor Name and Address"
          />
        </div>
      </td>
      <td>
        <div className="form-item">
          <label>
            <span className="label">As of petition filing date, the claim is:</span>
            <span className="schedule-tips">Check all that apply.</span>
          </label>
          <label>
            <Field name={`${creditor}.is_contingent`} component="input" type="checkbox" />
            Contingent<br/>
          </label>
          <label>
            <Field name={`${creditor}.is_unliquidated`} component="input" type="checkbox" />
            Unliquidated<br/>
          </label>
          <label>
            <Field name={`${creditor}.is_disputed`} component="input" type="checkbox" />
            Disputed
          </label>
        </div>
      </td>
      <td className="money">
        <div className="form-item">
          $ <Field name={`${creditor}.total_claim`} component="input" type="number" step="0.01" size="10"/>
        </div>
      </td>
      <td className="money">
        <div className="form-item">
          $ <Field name={`${creditor}.priority_amount`} component="input" type="number" step="0.01" size="10"/>
        </div>
      </td>
    </tr>

    <tr>
      <td>
        <div className="form-item">
          <label>
            <span className="label">Date or dates debt was incurred</span>
          </label>
          <Field name={`${creditor}.debt_date`} component="input" type="date"/>
        </div>
      </td>

      <td>
        <div className="form-item">
          <label>
            <span className="label">Basis for the claim</span>
          </label>
          <Field name={`${creditor}.claim_basis`} component="textarea" rows="3" cols="35" />
        </div>
      </td>
    </tr>

    <tr>
      <td>
        <div className="form-item">
          <label>
            <span className="label">Last 4 digits of account number</span>
          </label>
          <Field name={`${creditor}.account_number_last_4_digits`} component="input" type="number" size="4"/>
        </div>
      </td>

      <td>
        <div className="form-item">
          <label>
            <span className="label">Is the claim subject to offset?</span>
          </label>
          <Field name={`${creditor}.is_subject_to_offset`} component="select">
            <option value="">No</option>
            <option value="Yes">Yes</option>
          </Field>
        </div>
      </td>

    </tr>

    <tr>
      <td>
        <div className="form-item">
          <label>
            <span className="label">Specify Code subsection of PRIORITY unsecured claim:</span>
          </label>
          11 U.S.C. § 507(a) (
          <Field name={`${creditor}.usc_subsection`} component="input" type="number" size="4"/>
          )
        </div>
      </td>
    </tr>
    </tbody>
  </table>
)





/** WEBPACK FOOTER **
 ** ./src/scheduleform/ScheduleEFPriorityCreditorForm.jsx
 **/